<script>
    import axios from 'axios'
    import {Listeners} from "../../../../../constants/listeners";
    import AdaptersDialog from "../../../../../component/adapters/Dialog.vue";
    import {store} from "../../../store";
    import Divider from "primevue/divider";
    import RadioButton from "primevue/radiobutton";
    import AdaptersMessage from "../../../../../component/adapters/Message.vue";

    export default {
        data () {
            return {
                name: 'DeleteNode',
                loading: false,
                error: null,
                model: [],
                targetNode: -2,
                store: store,
            }
        },
        methods: {
            deleteNode() {
                let self = this;
                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: {targetNode: this.targetNode, node: this.model.map((item) => {return item.id})},
                })
                    .then(response => {
                        self.loading = false;

                        // выбранная папка куда перемещать ключи удаляемых папок
                        let targetNodeRemoveTo = self.$parent.$_tree.getNodeById(self.targetNode);
                        // удаление выбранных папок
                        self.model.forEach((item) => {
                            let removeNode = self.$parent.$_tree.getNodeById(item.id);
                            self.$parent.$_tree.removeNode(removeNode);
                        });

                        // обновление данных папки, куда перемещали ключи
                        // так как приходит массив из одного объекта - берем первый элемент
                        // (массив пустой, если в папке назначения нет ключей)
                        let nodeData = response.data.info[0];
                        if (nodeData) {
                            // в шаблонных данных приходит имя папки, но т.к. данная папка является системной - у неё
                            // нет наименования, удаляем из объекта
                            delete nodeData.name;
                            self.$parent.$_tree.updateNode(targetNodeRemoveTo, nodeData);
                        }

                        // обновление данных по папкам
                        self.$parent.setNodesInfo(self.$parent.$_tree.getNodesInfo());
                        self.store.mutations.setNodesInfo(self.$parent.$_tree.getNodesInfo());
                        // переходим в перемещаемую папку для удаления
                        self.store.mutations.setSelectNode(targetNodeRemoveTo);

                        self.onClose();
                    })
                    .catch(error => self.error = error.response.data.message)
                    .finally(() => self.loading = false);
            },
            onClose() {
                this.$emitter.emit(this.getDeleteNodeListenerCloseId);
            },
        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            getApiUrl(){
                return this.$config.API_URL + '/clustering/node/' + this.getUid + '/delete';
            },
            deleteTitle(){
                return this.model.map((item) => {return item.name}).join(', ');
            },
            getDeleteNodeListenerOpenId() {
                return Listeners.CLUSTER_POPUP_DELETE_NODE_OPEN;
            },
            getDeleteNodeListenerCloseId() {
                return Listeners.CLUSTER_POPUP_DELETE_NODE_CLOSE;
            },
        },

        mounted() {
            this.$emitter.on(Listeners.CLUSTER_DELETE_NODE, ({model, targetNode}) => {
                this.model  = model;
                if (targetNode) {
                    this.targetNode = targetNode;
                }
                this.$emitter.emit(this.getDeleteNodeListenerOpenId);
            });
        },
        components: {
            AdaptersDialog,
            Divider,
            RadioButton,
            AdaptersMessage,
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getDeleteNodeListenerOpenId"
        :listener-close-id="getDeleteNodeListenerCloseId"
        :header="$t('lang.cluster.remove_folder')"
        :loading="loading"
        :error-message="error"
        :callback-agree="deleteNode"
        :button-agree-label="$t('lang.main.btn.delete')"
        :callback-on-hide="onClose"
    >
        <template #content>
            <p>{{$t('lang.cluster.folders_to_delete')}} <b style="cursor: help;" v-tooltip="deleteTitle">{{model.length}}</b></p>
            <AdaptersMessage :message="$t('lang.cluster.folders_to_delete_notice')" severity="warn" />
            <Divider />
            <div class="formgroup-inline">
                <label>{{ $t('lang.cluster.select_folder') }}</label>
                <div class="field-radiobutton">
                    <RadioButton v-model="targetNode" inputId="f_deleted" name="targetNode" :value="-2" />
                    <label for="f_deleted">{{ $t('lang.cluster.f_deleted') }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton v-model="targetNode" inputId="f_unallocated" name="targetNode" :value="-1" />
                    <label for="f_unallocated">{{ $t('lang.cluster.f_unallocated') }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
